import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Route, Routes } from 'react-router';
import { PubRouteItems } from '../../routes';
import { ClaimType } from '@yakoffice/publisher-types';
import { GameEnvironmentsContainer } from '../gameEnvs/GameEnvironmentsContainer';
import { useRootStore } from '../../../loaders/useRootStore';
import { GameVersionsContainer } from '../gameVersions/GameVersionsContainer';
import { GameVersionIndex } from '../gameVersions/GameVersionIndex';
import styles from './project.module.scss';
import { matchDeeply, NoAccess } from '@yakoffice/shared-components';
import { NavigationRailLoader } from '../../components/navigation-rail-loader/navigation-rail-loader';
import { useProjectThemeContext } from '@yakoffice/project-theme';

export const Project: FC = observer(() => {

    const rootStore = useRootStore();
    const user = rootStore.authStore.currentAuthUser;
    const projectTheme = useProjectThemeContext();

    const publisherColorOverwrite = () => {

        const projectColor = projectTheme.getColor();

        if (projectColor.includes('soft'))
            return projectColor.replace(/soft/g, 'dark');

        if (projectColor.includes('medium'))
            return projectColor.replace(/medium/g, 'dark');

        if (projectColor === 'light-material' || projectColor === undefined)
            return 'dark-gray';

        return projectColor;
    };

    return (
        <div className={`${styles.project} project ${projectTheme.getColor()}`}>
            <NavigationRailLoader />
            <div className={`${styles.projectContent} projectContent publisher`}>
                <Routes>

                    <Route path={PubRouteItems.GameEnvironments}
                           element={user.hasProjectClaim(ClaimType.EditGameEnvironment) ?
                               <GameEnvironmentsContainer /> :
                               <NoAccess />} />

                    <Route path={matchDeeply(PubRouteItems.GameVersions, PubRouteItems.GameVersionIdParam)}
                           element={<GameVersionIndex />} />

                    <Route path={PubRouteItems.GameVersions}
                           element={user.hasProjectClaim(ClaimType.EditGameVersion) ? <GameVersionsContainer /> :
                               <NoAccess />} />

                </Routes>
            </div>
        </div>
    );
});

export default Project;
